module.exports = __webpack_public_path__ + "img/project9_1.png.3f646189.webp";